import Vue from "vue"
import VueDraggableResizable from "vue-draggable-resizable"

// optionally import default styles
import "vue-draggable-resizable/dist/VueDraggableResizable.css"

Vue.component("vue-draggable-resizable", VueDraggableResizable)
